"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var RemixOptionsContext_exports = {};
__export(RemixOptionsContext_exports, {
  ClerkRemixOptionsProvider: () => ClerkRemixOptionsProvider,
  useClerkRemixOptions: () => useClerkRemixOptions
});
module.exports = __toCommonJS(RemixOptionsContext_exports);
var import_react = __toESM(require("react"));
const ClerkRemixOptionsCtx = import_react.default.createContext(void 0);
ClerkRemixOptionsCtx.displayName = "ClerkRemixOptionsCtx";
const useClerkRemixOptions = () => {
  const ctx = import_react.default.useContext(ClerkRemixOptionsCtx);
  return ctx.value;
};
const ClerkRemixOptionsProvider = (props) => {
  const { children, options } = props;
  return /* @__PURE__ */ import_react.default.createElement(ClerkRemixOptionsCtx.Provider, { value: { value: options } }, children);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ClerkRemixOptionsProvider,
  useClerkRemixOptions
});
//# sourceMappingURL=RemixOptionsContext.js.map